import { makeAutoObservable } from "mobx";
import HistoricalBaselineData from "./HistoricalBaselineData";

export default class TaskPreBaseline {
  code;
  id;
  parent;
  name;
  plannedStartDate;
  plannedEndDate;
  plannedCost;
  plannedDuration;
  historicalBaselineData = [];

  constructor(
    code,
    id,
    parent,
    name,
    plannedStartDate,
    plannedEndDate,
    plannedCost,
    plannedDuration,
    historicalBaselineData
  ) {
    this.code = code;
    this.id = id;
    this.name = name;
    this.parent = parent;
    this.plannedCost = plannedCost;
    this.plannedDuration = plannedDuration;
    this.plannedStartDate = plannedStartDate;
    this.plannedEndDate = plannedEndDate;
    this.historicalBaselineData =
      historicalBaselineData === null || historicalBaselineData === undefined
        ? []
        : historicalBaselineData;

    makeAutoObservable(this);
  }

  toJS() {
    return {
      code: this.code,
      id: this.id,
      name: this.name,
      parent: this.parent,
      plannedStartDate: this.plannedStartDate,
      plannedEndDate: this.plannedEndDate,
      plannedCost: this.plannedCost,
      plannedDuration: this.plannedDuration,
      historicalBaselineData: this.historicalBaselineData.map((data) =>
        data.toJS()
      ),
    };
  }

  static fromJS(store, object, parent) {
    const taskPreBaseline = new TaskPreBaseline();
    if (object != null) {
      taskPreBaseline.name = object.name;
      taskPreBaseline.id = object.id;
      taskPreBaseline.code = object.code;
      taskPreBaseline.parent = parent;
      taskPreBaseline.plannedStartDate = object.plannedStartDate;
      taskPreBaseline.plannedEndDate = object.plannedEndDate;
      taskPreBaseline.plannedCost = object.plannedCost;
      taskPreBaseline.plannedDuration = object.plannedDuration;
      taskPreBaseline.historicalBaselineData =
        object.historicalBaselineData.map((data) =>
          HistoricalBaselineData.fromJS(data)
        );
    }
    return taskPreBaseline;
  }
}


